<template>
  <span
    v-if="state"
    v-b-tooltip.hover="{ customClass: 'vorgang-state-badge-tooltip' }"
    :title="tooltip"
    class="pill-badge pill-badge--vorgang-state"
    :style="farben"
  >
    {{ label }}
  </span>
</template>

<script>
import {
  vorgangStateColors,
  grauPillColors,
  pillColorStyleObject,
  formatDateWithoutHours,
} from '@/core/common/helpers/utils';

export default {
  name: 'VorgangStateBadge',
  props: {
    state: { type: String, default: null },
    buchungsbestaetigungsdatum: { type: String, default: null },
  },
  computed: {
    label() {
      return this.$t('VORGAENGE.blankStates.' + this.state);
    },
    farben() {
      return pillColorStyleObject(vorgangStateColors[this.state] ?? grauPillColors);
    },
    tooltip() {
      if (this.state !== 'Buchung' || !this.buchungsbestaetigungsdatum) return null;
      return 'Buchungsbestätigungsdatum: ' + formatDateWithoutHours(this.buchungsbestaetigungsdatum);
    },
  },
};
</script>

<style lang="scss">
.vorgang-state-badge-tooltip .tooltip-inner {
  max-width: none;
  white-space: nowrap;
}
</style>
